import type { CustomerOrderDetail } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { OrderAmountSummary } from './order-amount-summary';
import { OrderLinesTable } from './order-lines-table';
import { OrderTerms } from './order-terms';

interface OrderContentProps {
  readonly order: CustomerOrderDetail;
}

/**
 * 주문 내용(왼쪽 큰 칸) — 주문한 발행본의 품목 줄·합계(공급가액·부가세)·거래 조건. 값은 모두 발행본 사본에서 읽는다.
 * 같은 내용의 견적서(QuoteDocument)는 인쇄 때만 보인다.
 */
export const OrderContent = ({ order }: OrderContentProps): ReactElement => (
  <section aria-label="주문 내용" className="flex flex-col gap-8">
    <div className="flex flex-col gap-3">
      <p
        aria-hidden
        className="text-[11px] leading-none font-semibold tracking-[0.18em] text-muted-foreground uppercase"
      >
        Items
      </p>
      <h2 className="text-[clamp(1.5rem,2.4vw,2rem)] leading-[1.2] font-bold tracking-[-0.02em] text-balance">
        주문 내용
      </h2>
    </div>
    <OrderLinesTable lines={order.quoteVersion.lines} />
    <OrderAmountSummary version={order.quoteVersion} />
    <OrderTerms version={order.quoteVersion} />
  </section>
);
